module.exports = __webpack_public_path__ + "static/media/Nguyen_Manh_Hiep.19f72144.jpg";